import * as SelectPrimitive from "@radix-ui/react-select";
import classNames from "classnames";
import React from "react";
import { FeatherIcon } from "./FeatherIcon";

export function SelectRoot({
  value,
  onChange,
  children,
  className,
  contentClassName,
}: {
  value: string;
  onChange: (value: string) => void;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}) {
  return (
    <SelectPrimitive.Root
      value={value ?? "undefined"}
      onValueChange={(v) => {
        onChange(v);
      }}
    >
      <SelectPrimitive.Trigger
        className={classNames(
          "border border-neutral-200 hover:border-neutral-250 inline-flex gap-2 items-center justify-center px-2 text-neutral-700 bg-neutral-0 h-7 whitespace-nowrap rounded-sm transition",
          className
        )}
      >
        <SelectPrimitive.Value />
        <SelectPrimitive.Icon>
          <FeatherIcon icon="chevron-down" size="sm" />
        </SelectPrimitive.Icon>
      </SelectPrimitive.Trigger>
      <SelectPrimitive.Portal>
        <SelectPrimitive.Content
          className={classNames(
            "bg-neutral-0 border border-neutral-100 rounded overflow-hidden shadow select-none",
            contentClassName
          )}
        >
          <SelectPrimitive.ScrollUpButton className="flex items-center justify-center h-4">
            <FeatherIcon icon="chevron-up" size="sm" />
          </SelectPrimitive.ScrollUpButton>
          <SelectPrimitive.Viewport className="p-1">
            {children}
          </SelectPrimitive.Viewport>
          <SelectPrimitive.ScrollDownButton className="flex items-center justify-center h-4">
            <FeatherIcon icon="chevron-down" size="sm" />
          </SelectPrimitive.ScrollDownButton>
        </SelectPrimitive.Content>
      </SelectPrimitive.Portal>
    </SelectPrimitive.Root>
  );
}

export function SelectItem({
  value,
  text,
  className,
}: {
  value: string;
  text: string;
  className?: string;
}) {
  return (
    <SelectPrimitive.Item
      value={value}
      className={classNames(
        "flex items-center relative py-1.5 pl-6 pr-8 rounded-sm text-neutral-700 focus:bg-neutral-125 no-focus-visible",
        className
      )}
    >
      <SelectPrimitive.ItemText>{text}</SelectPrimitive.ItemText>
      <SelectPrimitive.ItemIndicator className="absolute left-0 flex p-1">
        <FeatherIcon icon="check" size="sm" />
      </SelectPrimitive.ItemIndicator>
    </SelectPrimitive.Item>
  );
}
